import { useEvent } from '@bizzabo/entities';
import { useNotificationSubscribe } from '../hooks/useNotificationSubscribe';
import { incomingCallAtom, eventIdAtom } from './atoms';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import Notification from './Notification';

export interface VideoNotificationsProps {
    eventUniqueName: string;
}

const VideoNotifications: React.FC<VideoNotificationsProps> = ({ eventUniqueName }) => {
    const { data: event } = useEvent(eventUniqueName);
    useNotificationSubscribe(event.id, eventUniqueName);
    const [incomingCall] = useAtom(incomingCallAtom);
    const [, setEventId] = useAtom(eventIdAtom);

    useEffect(() => {
        setEventId(event.id);
    }, [event.id, setEventId]);

    if (incomingCall.hasIncomingCall) {
        return <Notification incomingNotification={incomingCall.incomingNotification} />;
    }

    return null;
};

export default VideoNotifications;
